export enum TTMJ {
  ORF = "orf",
  PATREASON = "patreason",
  PICTURE = "picture_story",
  WORKMEM = "working_mem",
  ELISON = "elison",
  STORY = "story_retell"
}

export enum BALLI {
  ABILITY = "ability",
  ATTITUDE = "attitude",
  GRIT = "grit",
  REGULATION = "regulation"
}

export enum Module {
  BALA,
  BALLI,
  TTMJ
}
